// extracted by mini-css-extract-plugin
module.exports = {"Divider":"styles_Divider__16gNq","ContainerTable":"styles_ContainerTable__1h6Sd","ContainerTableColunas":"styles_ContainerTableColunas__1D_bO"};